// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1bBuM","productName":"Table_productName__fDCrW"};